<template>
  <div>
    <!--TOOLBAR-->
    <v-app-bar color="red-darken-3" class="pt-1">
      <v-app-bar-title>{{ $t("leko_employees.tools.label") }}</v-app-bar-title>
      <v-divider class="mx-5 hidden-md-and-down" inset vertical />
    </v-app-bar>
    <!--GLOBAL ALERT-->
    <v-alert
      :model-value="alert.value"
      :type="alert.type"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>
    <!--TOOLS-->
    <v-row class="ma-4">
      <v-col xs="12" sm="8">
        <v-toolbar color="red-darken-3" dark>
          <v-toolbar-title>
            {{ $t("leko_employees.tools.export_inventory") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-row class="pt-2">
            <!-- INSTITUTION -->
            <v-col xs="12">
              <v-autocomplete
                v-model="institution"
                :items="institutions"
                :loading="loadingInstitution"
                :label="$t('parts.advanced_search.institution')"
                item-title="title"
                item-value="_id"
                variant="outlined"
                prepend-icon="mdi-office-building-outline"
                solo
                color="red-darken-1"
                class="ml-2 mr-2"
                hide-details
              />
            </v-col>
            <!-- STARTING DATE -->
            <v-col xs="12" sm="6">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="startDate"
                    :value="formatDateToDisplay(startDate)"
                    :label="$t('parts.advanced_search.starting_date')"
                    :hint="$t('parts.advanced_search.select_starting_date')"
                    variant="outlined"
                    flat
                    color="black"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  v-model="startDate"
                  color="red-darken-3"
                  :max="endDate || null"
                  @update:model-value="startDateMenu = false"
                />
              </v-menu>
            </v-col>
            <!-- ENDING DATE -->
            <v-col xs="12" sm="6">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="endDate"
                    :value="formatDateToDisplay(endDate)"
                    :label="$t('parts.advanced_search.ending_date')"
                    :hint="$t('parts.advanced_search.select_ending_date')"
                    variant="outlined"
                    flat
                    color="black"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  v-model="endDate"
                  color="red-darken-3"
                  :min="startDate || null"
                  @update:model-value="endDateMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col>
              <v-row>
                <v-btn variant="flat" icon class="mt-2" @click="clear">
                  <v-icon color="grey-darken-4"> mdi-broom </v-icon>
                </v-btn>

                <!-- <v-btn
                  dark
                  color="grey-darken-4"
                  @click="exportInventory"
                >
                  {{ $t('leko_employees.tools.export') }}
                  <v-icon right>
                    file_download
                  </v-icon>
                </v-btn> -->
                <v-btn variant="flat" color="grey-darken-4" class="mt-2">
                  {{ $t("leko_employees.tools.export") }}
                  <v-icon end> mdi-download </v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import getRequest from "../api/getRequest";

export default {
  data: () => ({
    loading: false,
    loadingInstitution: false,
    alert: {
      value: false,
      type: "info",
      message: String,
    },
    institution: null,
    institutions: [],
    startDateMenu: false,
    startDate: null,
    endDateMenu: false,
    endDate: null,
  }),
  created() {
    this.getInstitutions();
  },
  methods: {
    clear() {
      this.institution = null;
      this.startDate = null;
      this.endDate = null;
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },
    exportInventory() {
      this.loading = true;
      getRequest(
        "/tools/export-inventory",
        `institution_id=${this.institution}&starting_date=${this.startDate}&ending_date=${this.endDate}`,
      )
        .then(() => {
          this.alert = {
            value: true,
            type: "info",
            message: this.$t(
              "leko_employees.tools.alerts.export_inventory_success",
            ),
          };
          setTimeout(() => {
            this.alert.value = false;
          }, 5000);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateToDisplay(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 0-indexed
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
